module.exports = __webpack_public_path__ + "static/img/10@2x.57c0a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/10@2x.png
// module id = pD0P
// module chunks = 1